"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFilters = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OrderFilters = typebox_1.Type.Partial(typebox_1.Type.Object({
    status: typebox_1.Type.String(), // Comma separated list of statuses
    billingStatus: typebox_1.Type.String(), // Comma separated list of billingStatuses
    customerID: typebox_1.Type.String(),
    requestedPickupDate_gte: typebox_1.Type.String(),
    requestedPickupDate_lte: typebox_1.Type.String(),
    expectedPickupDate_gte: typebox_1.Type.String(),
    expectedPickupDate_lte: typebox_1.Type.String(),
    requestedDeliveryDate_gte: typebox_1.Type.String(),
    requestedDeliveryDate_lte: typebox_1.Type.String(),
    expectedDeliveryDate_gte: typebox_1.Type.String(),
    expectedDeliveryDate_lte: typebox_1.Type.String(),
    disposalSiteID: typebox_1.Type.String(),
    serviceLocationCounty: typebox_1.Type.String(),
    material: typebox_1.Type.String(), // Comma separated list of materials
    orderID: typebox_1.Type.String(), // Comma separated list of orderIDs
    // added with billing
    createdDate_gte: typebox_1.Type.String(),
    createdDate_lte: typebox_1.Type.String(),
    containerTypeID: typebox_1.Type.String(), // Comma separated list of containerTypeIDs
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortDescending: typebox_1.Type.Boolean(),
}));
//# sourceMappingURL=order-filters.js.map